var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3082 9.53874L15.0147 16.9232M10.9521 16.9232L10.6586 9.53874M19.1162 6.90497C19.4064 6.94763 19.6949 6.99276 19.9834 7.04117M19.1162 6.90497L18.2101 18.2958C18.1731 18.7596 17.9564 19.1928 17.6034 19.5087C17.2504 19.8247 16.7871 20.0001 16.3061 20H9.66073C9.17972 20.0001 8.71639 19.8247 8.36338 19.5087C8.01037 19.1928 7.79372 18.7596 7.75673 18.2958L6.85055 6.90497M19.1162 6.90497C18.137 6.7618 17.1527 6.65315 16.1652 6.57923M6.85055 6.90497C6.56037 6.94681 6.27188 6.99194 5.9834 7.04035M6.85055 6.90497C7.82981 6.76181 8.81414 6.65316 9.80158 6.57923M16.1652 6.57923V5.82766C16.1652 4.85948 15.3931 4.05212 14.3919 4.02176C13.4531 3.99275 12.5137 3.99275 11.5749 4.02176C10.5737 4.05212 9.80158 4.8603 9.80158 5.82766V6.57923M16.1652 6.57923C14.0472 6.42094 11.9196 6.42094 9.80158 6.57923",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDelete);
export default __webpack_public_path__ + "static/media/ico-delete.c236d8b7e30eaaf7eec99d89ca4ffccc.svg";
export { ForwardRef as ReactComponent };